export const transferListStyle = theme => ({
    margin: 'auto',
    button: {
        margin: theme.spacing(0.5, 0),
    },
    paper: {
        height: 275,
        overflow: 'auto',
    },
    footer: {
        height: 70,
        overflow: 'hidden'
    }
})